import { Link } from 'react-router-dom';

/**
 * Render text with clickable URLs and in-app link detection.
 * - External URLs open in a new tab
 * - In-app URLs (dmvsoundstage.com) navigate within the app via React Router
 * - Handles @mentions as profile links
 */
export default function RichText({ text }) {
  if (!text) return null;

  const URL_REGEX = /(https?:\/\/[^\s<]+[^\s<.,;:!?'"\])])/gi;
  const MENTION_REGEX = /@([a-zA-Z0-9_]+)/g;
  const COMBINED = new RegExp(
    `(${URL_REGEX.source})|(${MENTION_REGEX.source})`,
    'gi'
  );

  const parts = [];
  let lastIndex = 0;
  let match;

  const combinedRegex = new RegExp(COMBINED.source, 'gi');
  while ((match = combinedRegex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push({ type: 'text', value: text.slice(lastIndex, match.index) });
    }

    if (match[1]) {
      const url = match[1];
      const isInApp = url.includes('dmvsoundstage.com') || url.includes(window.location.host);
      if (isInApp) {
        try {
          const urlObj = new URL(url);
          parts.push({ type: 'inapp', value: url, path: urlObj.pathname });
        } catch {
          parts.push({ type: 'url', value: url });
        }
      } else {
        parts.push({ type: 'url', value: url });
      }
    } else if (match[3]) {
      parts.push({ type: 'mention', value: match[0], handle: match[4] || match[3] });
    }

    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push({ type: 'text', value: text.slice(lastIndex) });
  }

  if (parts.length === 0) return <>{text}</>;

  return (
    <>
      {parts.map((part, i) => {
        switch (part.type) {
          case 'url':
            return (
              <a
                key={i}
                href={part.value}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:underline break-all"
                data-testid="post-link"
                onClick={(e) => e.stopPropagation()}
              >
                {part.value}
              </a>
            );
          case 'inapp':
            return (
              <Link
                key={i}
                to={part.path}
                className="text-primary hover:underline break-all"
                data-testid="post-inapp-link"
                onClick={(e) => e.stopPropagation()}
              >
                {part.value}
              </Link>
            );
          case 'mention':
            return (
              <Link
                key={i}
                to={`/u/${part.handle}`}
                className="text-primary font-medium hover:underline"
                data-testid="post-mention-link"
                onClick={(e) => e.stopPropagation()}
              >
                {part.value}
              </Link>
            );
          default:
            return <span key={i}>{part.value}</span>;
        }
      })}
    </>
  );
}
